import React from 'react';
import './Success.scss';
import Progress from '../Progress/Progress';
import SampleCard from './SampleCard';

export interface SampleCardProps {
  title: string;
  subtitle: string;
  image: string;
  actionLink: string;
  actionText: string;
}

const cards: SampleCardProps[] = [
  {
    title: 'Salesforce Talent Alliance:',
    subtitle: 'Pledge to build a diverse workforce',
    image: 'salesforce-talent-alliance.jpg',
    actionText: 'Let’s go',
    actionLink: 'https://go.salesforce-partners.com/talent-alliance',
  },
  {
    title: 'Partner Learning Camp:',
    subtitle: 'Build, sell and implement faster and better than ever',
    image: 'partner-learning-camp.jpg',
    actionText: 'Start now',
    actionLink: 'https://go.salesforce-partners.com/trailhead-for-partners-home',
  },
];

const Success: React.FC<{}> = () => {
  return (
    <div id="success" className="v2">
      <Progress currentSlide={6} fromSlides={6} hideLabel />

      <h2>Thank you!</h2>
      <p>Check your email to find curated content to help you on your talent journey.</p>
      <div className={'container'}>
        {cards.map((card, index) => {
          return (
            <SampleCard
              key={`card-${index}`}
              title={card.title}
              subtitle={card.subtitle}
              image={card.image}
              actionLink={card.actionLink}
              actionText={card.actionText}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Success;
